<div
  class="absolute z-50 max-h-max rounded-lg bg-white p-4 shadow-xl"
  [style.top.px]="localTop()"
  [style.left.px]="localLeft()"
  [style.width.px]="maxWidth"
>
  <div class="flex items-center gap-3">
    <h2 class="text-lg font-bold tracking-wider">{{ taskTitle() }}</h2>
  </div>

  <ag1-button-small
    class="absolute right-2 top-2"
    variant="tertiary"
    (clickEvent)="closeComponent()"
  >
    <svg-icon src="/assets/icons/general/close.svg" />
  </ag1-button-small>
  <hr class="m-0 mb-1" />
  <div ng-controller="UploadController">
    <form class="m-0 mb-2" [formGroup]="uploadForm">
      @if (localTask().file) {
        <table class="is-fullwidth is-responsive table">
          <thead>
            <tr>
              <th class="w-5"></th>
              <th>File</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <ag1-button-small
                  tooltip="Delete"
                  (clickEvent)="showDeleteDocumentConfirmModal()"
                  variant="danger"
                  classOverrides="!text-white !bg-red-700"
                >
                  <svg-icon src="/assets/icons/general/remove.svg" />
                </ag1-button-small>
              </td>
              <td data-label="File">
                <a [attr.href]="localTask().file.v2Url" target="_blank">
                  <span class="hidden 2xl:inline">{{
                    localTask().file.filename | truncate: 30
                  }}</span>
                  <span class="hidden md:inline 2xl:hidden">{{
                    localTask().file.filename | truncate: 60
                  }}</span>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      } @else {
        <div class="rounded-md border bg-white !p-1 shadow-sm">
          <div
            [class.hidden]="file"
            fxLayout="column"
            fxLayoutAlign="stretch"
            fxFlex="75%"
          >
            <div fxLayout="column" fxLayoutAlign="stretch" fxFlex="auto">
              <dropzone
                class="h-[130px]"
                [config]="config"
                fxLayout="row"
                fxLayoutAlign="start stretch"
                fxFlex="auto"
                message="<h4 class='is-size-4'>Drop Zone</h4> <p>Drag & drop file here or click to upload.</p>"
                (addedFile)="dropzoneEvent($event)"
              />
            </div>
          </div>
          @if (file) {
            <table class="is-fullwidth is-responsive table">
              <thead>
                <tr>
                  <th class="w-5"></th>
                  <th>File</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <ag1-button-small
                      tooltip="Delete"
                      (clickEvent)="removeFromUpload()"
                      variant="danger"
                      classOverrides="!text-white !bg-red-700"
                    >
                      <svg-icon src="/assets/icons/general/remove.svg" />
                    </ag1-button-small>
                  </td>
                  <td class="!align-middle" data-label="File">
                    <span class="hidden 2xl:inline">{{
                      file.name | truncate: 30
                    }}</span>
                    <span class="hidden md:inline 2xl:hidden">{{
                      file.name | truncate: 60
                    }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          }
        </div>
      }
      <label for="uploadDate">Upload Date</label>
      <input
        id="uploadDate"
        formControlName="uploadDate"
        type="date"
        disabled="true"
        [max]="maxTaskDate"
      />
      <label for="customDate">Custom Date</label>
      <input
        id="customDate"
        formControlName="customDate"
        type="date"
        disabled="{{ !localTask().customDate }}"
        [max]="maxTaskDate"
      />
    </form>
    <div class="columns-2 flex-col">
      <ag1-button
        (clickEvent)="submitForm()"
        [disabled]="disableUpload"
        class="py-2"
        >Upload</ag1-button
      >
      @if (fileUploading) {
        <div>
          <ag-spinner [size]="2" />
        </div>
      }
    </div>
    @if (localTask().platformDocuments) {
      <ag1-table-base-old
        class="m-1 w-full"
        [tableService]="ag1TableService"
        tableName="PlatformDocuments"
        [customBodyCellRef]="customBodyCellTemplate"
      />
    }
  </div>
</div>

<ng-template #customBodyCellTemplate let-item="item" let-field="field">
  @if (field.name === "filename") {
    <ag1-link
      variant="secondary"
      [label]="item.filename"
      (clickEvent)="onDownloadClick(item)"
    />
  }
</ng-template>
